// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"fd669b4b","510":"2af403bd","583":"198891af"}[chunkId] + ".chunk.js";
};